import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import Pagination from 'components/Pagination';
import Footer from '../Footer';
import qs from 'qs';
import * as Schedule from 'components/Tables/ScheduleList';
import * as DataList from 'components/DataList';

@inject('store', 'jobStore', 'viewStore') @observer
class AssignmentsTable extends Component {

  onPaginationChange(newPage) {
    let {
      viewStore: {
        jobSearch
      }
    } = this.props;
    this.props.viewStore.jobSearch = {
      ...jobSearch,
      page: newPage
    };
    this.props.viewStore.assignments();
  }

  render() {
    let {
      viewStore,
      jobStore,
      viewStore: {
        jobTab: {
          section
        }
      },
      jobStore: {
        jobs: {
          objects,
          meta
        }
      }
    } = this.props;
    

    if (objects.length === 0) {
      return (
        <Schedule.Empty
          noun="assignments"
          search={viewStore.jobSearch}
          onClearFilters={() => { viewStore.clearJobFilters(); viewStore.assignments(); }}
          onWiden={() => { viewStore.widenJobDateRange(3); viewStore.assignments(); }}
        />
      );
    }

    return(
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group responsive-pagination bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <DataList.List
          columns={Schedule.ASSIGNMENT_COLUMNS}
          cards={Schedule.ASSIGNMENT_CARDS}
          minTableWidth={Schedule.MIN_TABLE_WIDTH}
          total={meta.total_records || objects.length}
          noun="assignments"
          note={DataList.sortNote(viewStore.jobSearch.order)}
        >
          {objects.map((assignment) => {
            const attributes = assignment.attributes;
            const job = attributes.job || {};
            const serviceType = attributes.service_type || {};
            const agreement = attributes.service_agreement && attributes.service_agreement.number;
            let progress = null;
            if (attributes.completed_at) {
              progress = Schedule.clockTime(attributes.completed_at);
            } else if (attributes.started_at) {
              progress = `since ${Schedule.clockTime(attributes.started_at)}`;
            }
            return (
              <DataList.Row key={assignment.id} accent={Schedule.accentFor(serviceType.color)}>
                <DataList.Cell area="when">
                  <Schedule.When start={attributes.start_date} end={attributes.end_date} />
                </DataList.Cell>
                <DataList.Cell area="number">
                  <Schedule.JobNumber
                    number={attributes.event_number}
                    link={`/dashboard/jobs/${job.id}/${section}`}
                    title={job.title}
                    serviceType={serviceType}
                  />
                </DataList.Cell>
                <DataList.Cell area="job">
                  <Schedule.JobTitle
                    title={job.title}
                    details={[
                      Schedule.poLabel(job.po_number),
                      agreement && `Agreement ${agreement}`,
                    ]}
                  />
                </DataList.Cell>
                <DataList.Cell area="team">
                  {attributes.technician_name && attributes.technician_name !== 'Unassigned' ? (
                    <Schedule.Person name={attributes.technician_name} status={attributes.status} note={progress} />
                  ) : (
                    <Schedule.Unassigned />
                  )}
                </DataList.Cell>
                <DataList.Cell area="client">
                  <Schedule.Client
                    name={attributes.client_name}
                    link={attributes.client && attributes.client.id
                      ? `/dashboard/clients/${attributes.client.id}?${qs.stringify(viewStore.clientShowSearch, { encode: false })}`
                      : null}
                    location={attributes.location}
                  />
                </DataList.Cell>
                <DataList.Cell area="actions">
                  <Schedule.EditJob
                    onEdit={() => jobStore.openEditJobDrawer(job.id, { reloadList: 'assignments' })}
                  />
                </DataList.Cell>
              </DataList.Row>
            );
          })}
        </DataList.List>
      </React.Fragment>
    )
  }

};

export default AssignmentsTable;